import {HttpClient, ObservableBuilder} from '@esgi/api';
import {StateStandardResponse} from 'shared/modules/state-standards-library/models';

export class Api {

	public static getStateStandardLibrary(stateID: number): ObservableBuilder<StateStandardResponse> {
		return HttpClient.default.ESGIApi.get<StateStandardResponse>('assets/test-details', 'get-state-standard-library', {stateID: stateID});
	}
}
